export default __webpack_public_path__ + "static/media/safecheckout_line.b9895b26.webp";